import { useState } from "react";
import { api } from "@/lib/api";
import { logger } from "@/lib/logger";
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { usePasswordForm } from "@/components/password/usePasswordForm";
import { PasswordField, PasswordRequirements } from "@/components/password/PasswordFields";

export default function ChangePasswordDialog({ trigger }) {
  const [open, setOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const form = usePasswordForm();

  const close = () => { setOpen(false); form.reset(); setShowNew(false); };

  const salvar = async () => {
    if (!form.canSubmit) return;
    setSaving(true);
    try {
      await api.put("/auth/password", { current_password: form.cur, new_password: form.novo });
      toast.success("Senha alterada com sucesso. Faça login novamente nas outras sessões.");
      close();
    } catch (e) {
      logger.error("Falha ao alterar senha", e);
      toast.error(e.response?.data?.detail || "Erro ao alterar senha");
    } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => (v ? setOpen(true) : close())}>
      <DialogTrigger asChild>
        {trigger || (
          <Button size="sm" variant="ghost" className="text-white hover:bg-white/10" data-testid="btn-change-pwd">
            <KeyRound className="w-4 h-4 mr-1" /> Alterar Senha
          </Button>
        )}
      </DialogTrigger>
      <DialogContent className="max-w-md" data-testid="dialog-change-pwd">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-[#083CA6]">
            <KeyRound className="w-5 h-5" /> Alterar minha senha
          </DialogTitle>
          <DialogDescription>Para sua segurança, confirmamos a senha atual antes de atualizar.</DialogDescription>
        </DialogHeader>

        <div className="space-y-3">
          <PasswordField label="Senha atual" value={form.cur} onChange={form.setCur}
                         testId="input-current-pwd" autoComplete="current-password" />
          <PasswordField label="Nova senha" value={form.novo} onChange={form.setNovo}
                         testId="input-new-pwd" autoComplete="new-password"
                         show={showNew} onToggleShow={() => setShowNew((v) => !v)} />
          <PasswordField label="Confirmar nova senha" value={form.conf} onChange={form.setConf}
                         testId="input-confirm-pwd" autoComplete="new-password"
                         show={showNew} onToggleShow={() => setShowNew((v) => !v)} />
          <PasswordRequirements rules={form.rules} />
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={close} data-testid="btn-cancel-pwd">Cancelar</Button>
          <Button onClick={salvar} disabled={!form.canSubmit || saving}
                  className="bg-[#083CA6] hover:bg-[#062f85]" data-testid="btn-save-pwd">
            {saving ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <KeyRound className="w-4 h-4 mr-2" />}
            Alterar senha
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
